import { Controller } from "stimulus"

// Connects to data-controller="nocp-filter"
export default class extends Controller {
  static targets = ["form"]

  connect() {
    console.log('NOCP filter controller connected')
    console.log('Form target found:', this.hasFormTarget)
  }

  filter(event) {
    console.log('Filter triggered, submitting form')
    // Submit the form when the select changes
    if (this.hasFormTarget) {
      // Use submit() instead of requestSubmit() for better compatibility
      this.formTarget.submit()
    } else {
      console.error('Form target not found!')
    }
  }
}
